import { Injectable } from '@angular/core';
import { ApiHelperService } from '../../core/api-helper.service';
import { CostComparison } from '../cost-comparison/cost-comparison.model';
import { CostComparisonService } from '../cost-comparison/cost-comparison.service';
import { Merchant } from '../merchant/merchant.model';
import { MerchantService } from '../merchant/merchant.service';
import { User } from '../user/user.model';

import { ProposalStatus, ProposalListItem, Proposal } from './proposal.model';
import { UntypedFormGroup } from '@angular/forms';

export type FullProposal = {
    proposal: Proposal,
    costComparisons: CostComparison[],
    merchant: Merchant
    owner: User
};


@Injectable({
    providedIn: 'root'
})
export class ProposalService {
    options = { authenticate: true, setRoot: true };

    constructor(
        private api: ApiHelperService,
        // TODO (jacob): not sure I like this
        private costComparisonService: CostComparisonService,
        private merchantService: MerchantService
    ) { }

    createProposal(merchantId: string, costComparisonObjects: CostComparison[], costComparisonEditForms: UntypedFormGroup[], createdBy: string): Promise<string | null> {
        return this.api.apiCallSane(
            '/proposal',
            'PUT',
            this.api.getDefaultHeaders(),
            null,
            {
                status: ProposalStatus.open,
                merchantId,
                createdBy
            },
            this.options).then((prop: Proposal) =>  Promise.all([
                this.costComparisonService
                    .addCostComparisonToProposal(prop.id!, costComparisonObjects, costComparisonEditForms),
                Promise.resolve(prop.id)

            ])).then((values) => values[1]);
    }

    patch(id: string, data: Partial<Proposal>): Promise<Proposal> {
        return this.api.apiCallSane(
            '/proposal',
            'PATCH',
            this.api.getDefaultHeaders(),
            { id },
            data,
            this.options);
    }

    async getProposalById(id: string): Promise<Proposal> {
        return this.api.apiCallSane(
            '/proposal',
            'GET',
            this.api.getDefaultHeaders(),
            { id },
            null,
            this.options);
    }

    getProposalByToken(shareToken: string): Promise<FullProposal> {
        return this.api.apiCallSane(
            '/anon/proposal',
            'GET',
            this.api.getDefaultHeaders(),
            { shareToken },
            null,
            this.options);
    }

    getProposalByMerchantId(merchantId: string): Promise<Proposal | null> {
        return this.api.apiCallSane(
            '/proposal',
            'GET',
            this.api.getDefaultHeaders(),
            { merchantId },
            null,
            this.options)
            .then((pp: Partial<Proposal> | null) => pp == null
                ? pp as null
                : new Proposal(pp));
    }

    /**
     * Used to populate the Proposals page.
     *
     * The default proposal object wasn't quite what I wanted, so I added
     * ProposalListItem.
     */
    getProposalListItemsByOrganizationId(organizationId: string): Promise<ProposalListItem[]> {
        return this.api.apiCallSane(
            '/agg/proposals/preview/by-org',
            'GET',
            this.api.getDefaultHeaders(),
            { organizationId },
            null,
            this.options);
    }

    deleteProposal(id: string): Promise<void> {
        return this.api.apiCallSane(
            '/proposal',
            'DELETE',
            this.api.getDefaultHeaders(),
            { id },
            null,
            this.options);
    }
}
